import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pre-submission-modal',
  standalone: false,
  templateUrl: './pre-submission-modal.component.html',
  styleUrl: './pre-submission-modal.component.scss'
})
export class PreSubmissionModalComponent implements OnInit {
  isActiveMct: boolean = true;
  userstage: string = 'newMCTUser';
  constructor(
    public dialogRef: MatDialogRef<PreSubmissionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
    this.userstage = this.data?.userstage ? this.data.userstage : 'newMCTUser';
  }


  ngOnInit(): void { }


  yesClicked(): void {
    this.cancelClicked();
  }

  noClicked(): void {
    this.userstage = 'newMCTUser';
  }


  cancelClicked(): void {
    this.dialogRef.close('cancel');
  }

  continueClicked(): void {
    this.userstage = 'FTE_USER';
  }

  FTEAction(): void {
    this.userstage = 'ISCPCertificationModalConfimation';
  }

  ISCPYesClicked(): void {
     this.dialogRef.close('ISCPFlow');
  }

  ISCPNoClicked(): void {
     this.dialogRef.close('ILTFlow');
  }

}
